import * as ErrorLogger from '../Logging/ErrorLogger';
const storageKey = 'consent_storage';

export const SaveSelectedOptions = async (selectedOptions: Array<number>): Promise<void> => {
  try {
    localStorage.setItem(storageKey, JSON.stringify(selectedOptions));
  } catch (e) {
    ErrorLogger.log('LocalStorage Error' ,e);
  }
};

export const GetSelectedOptions =  (): Array<number> => {
  try {
    const item = localStorage.getItem(storageKey);
    return !!item ? JSON.parse(item) : [];
  } catch (e) {
    ErrorLogger.log('LocalStorage Error' ,e);
    return [];
  }
};
